__turbopack_context__.v({
  "amenities": "theater-module-scss-module__PMYJhW__amenities",
  "theater": "theater-module-scss-module__PMYJhW__theater",
});
